// Per-channel composer drafts, persisted to localStorage so a half-typed
// message survives channel switches and reloads. One key per channel; empty
// drafts are removed so we don't accumulate dead keys.
const PREFIX = 'chatapp_draft_';

export function loadDraft(channelId: string): string {
  try {
    return localStorage.getItem(PREFIX + channelId) ?? '';
  } catch {
    return '';
  }
}

export function saveDraft(channelId: string, value: string): void {
  try {
    if (value) localStorage.setItem(PREFIX + channelId, value);
    else localStorage.removeItem(PREFIX + channelId);
  } catch {
    /* ignore quota/availability errors */
  }
}

export function clearDraft(channelId: string): void {
  saveDraft(channelId, '');
}
